import React, { useRef, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegCheckCircle } from "react-icons/fa";

function TopLabelInput(props) {
    const {
        id,
        isChecked,
        onTypeCheck,
        purchase_type,
        addTypeCheck,
        label,
        readOnly,
        className = "input-wrapper",
        selectedType,
        errors,
    } = props;
    const InputRef = useRef(null);

    //   useEffect(() => {
    //     if (errors?.[props.name]) InputRef.current?.focus();
    //   }, [errors]);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onTypeCheck(e, purchase_type);
        }
    };

    return (
        <div class={className}>
            {label && <label for="first">{label}</label>}
            <input
                type={props?.type ? props.type : "text"}
                value={props?.value ? props.value : ""}
                name={props.name}
                placeholder={props.placeholder}
                onChange={props.onChange}
                readOnly={readOnly}
                className={addTypeCheck && !selectedType ? "error-field" : ""}
                ref={InputRef}
            />
            {addTypeCheck &&
                (isChecked ? (
                    <FaCheckCircle className="type-check type-checked" />
                ) : (
                    <FaRegCheckCircle
                        className="type-check type-unchecked"
                        type="button"
                        onClick={(e) => onTypeCheck(e, purchase_type)}
                        name={purchase_type}
                        tabIndex="0"
                        role="button"
                        onKeyDown={handleKeyDown}
                    />
                ))}
        </div>
    );
}

export default TopLabelInput;
